import { useState } from "react";
import { useAigcIntl } from "../../utils/utils";



const useUploadForm = (props: any) => {
  const { name, website, toolValue, sceneValue, description } = props;
  const { formatMessage, isEn } = useAigcIntl("upload");
  // 错误校验信息
  const [nameError, setNameError] = useState('');
  const [nameEnError, setNameEnError] = useState('');
  const [websiteError, setWebsiteError] = useState('');
  const [websiteEnError, setWebsiteEnError] = useState('');
  const [typeError, setTypeError] = useState('');
  const [typeEnError, setTypeEnError] = useState('');
  const [applicationError, setApplicationError] = useState('');
  const [applicationEnError, setApplicationEnError] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [descriptionEnError, setDescriptionEnError] = useState('');

  const checkNoValue = (value: any) => {
    if (!value || value?.length === 0) return true;
    return false;
  };

  const checkName = () => {
    if (checkNoValue(name)) {
      setNameError('请输入工具/案例名称');
      setNameEnError('Please enter the name of the tool/case');
      return true;
    } 
    setNameError('');
    setNameEnError('');
    return false;
    
  };

  const checkWebsite = () => {
    if (checkNoValue(website)) {
      setWebsiteError('请输入网址');
      setWebsiteEnError('Please enter the website');
      return true;
    } if (!(/^(http|https):\/\/[a-z0-9-]+(\.[a-z0-9-]+)+([/?#][^\s]*)?$/i.test(website))) {
      setWebsiteError('网址格式不正确');
      setWebsiteEnError('The URL format is incorrect');
      return true;
    } 
    setWebsiteError('');
    setWebsiteEnError('');
    return false;
    
  };

  const checkType = () => {
    if (checkNoValue(toolValue)) {
      setTypeError('请选择工具/案例类型');
      setTypeEnError('Please select the type of tool/case');
      return true;
    } 
    setTypeError('');
    setTypeEnError('');
    return false;
    
  };

  const checkApplication = () => {
    if (checkNoValue(sceneValue)) {
      setApplicationError('请选择应用场景');
      setApplicationEnError('Please select the application scenario');
      return true;
    } 
    setApplicationError('');
    setApplicationEnError('');
    return false;
    
  };

  const checkDescription = () => {
    if (checkNoValue(description)) {
      setDescriptionError('请输入简介');
      setDescriptionEnError('Please enter the brief description');
      return true;
    } 
    setDescriptionError('');
    setDescriptionEnError('');
    return false;
    
  };

  return {
    checkName,
    nameError,
    nameEnError,
    checkWebsite,
    websiteError,
    websiteEnError,
    checkType,
    typeError,
    typeEnError,
    checkApplication,
    applicationError,
    applicationEnError,
    checkDescription,
    descriptionError,
    descriptionEnError,
  };

};

export default useUploadForm;